import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import bindMethods from 'auto-bind';

import { setPurpose } from '../state/navigationSelection';
import { resetTeamsData } from '../state/teams';
import { resetSeasonsData } from '../state/seasons';
import { resetGamesData } from '../state/games';
import { disableToggle } from '../state/sidebar';
import { resetTeamSeasonGameSelection } from '../state/teamSeasonGameSelection';
import { generatePurposeOptions } from '../utils/generateNavigationOptions';
import { getPurposeValue } from '../state/selectors/getNavigationValue';
import NavigationItemPicker from './NavigationItemPicker';

class PurposePicker extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  generateOptions() {
    const { group, purposes } = this.props;
    const options = generatePurposeOptions(group, purposes);
    return options;
  }

  selectPurpose(purposeName) {
    const { getPurposeValue: value, setPurpose } = this.props;

    if (purposeName === value.value) {
      return;
    }

    const purpose = purposeName;
    const {
      resetTeamsData,
      resetSeasonsData,
      resetGamesData,
      resetTeamSeasonGameSelection,
      disableToggle,
    } = this.props;
    setPurpose(purpose);
    resetTeamsData();
    resetSeasonsData();
    resetGamesData();
    resetTeamSeasonGameSelection();
    disableToggle();
  }

  handleChange(value) {
    this.selectPurpose(value.value);
  }

  render() {
    const { isLoaded } = this.props;
    if (!isLoaded) {
      return null;
    }

    const { t, getPurposeValue } = this.props;

    return (
      <NavigationItemPicker
        selectId="NavigationBar.DropDown.Purpose"
        value={getPurposeValue}
        options={this.generateOptions()}
        onChange={this.handleChange}
        theme="general"
        placeholder={t('NavigationBar.Placeholders.Purpose')}
        noOptionsMessage={() => t('NavigationBar.NoOptionsMessage.Purpose')}
      />
    );
  }
}

PurposePicker.propTypes = {
  t: PropTypes.func.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  purposes: PropTypes.object,
  group: PropTypes.object,
  setPurpose: PropTypes.func.isRequired,
  getPurposeValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  resetTeamsData: PropTypes.func.isRequired, // supplied from Redux
  resetSeasonsData: PropTypes.func.isRequired, // supplied from Redux
  resetGamesData: PropTypes.func.isRequired, // supplied from Redux
  resetTeamSeasonGameSelection: PropTypes.func.isRequired, // supplied from Redux
  disableToggle: PropTypes.func.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  isLoaded: state.purposes.isLoaded,
  purposes: state.purposes.purposes,
  group: state.navigationSelection.group,
  getPurposeValue: getPurposeValue(state),
});

const mapDispatchToProps = {
  setPurpose,
  resetTeamsData,
  resetSeasonsData,
  resetGamesData,
  resetTeamSeasonGameSelection,
  disableToggle,
};

const TranslatedComponent = withTranslation()(PurposePicker);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranslatedComponent);
